import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Observable} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';

@Component({
    selector: 'app-tiktok-profile-title',
    templateUrl: './profile-title.component.html',
    styleUrls: ['./profile-title.component.scss'],
    standalone: false
})
export class ProfileTitleComponent implements OnInit {

  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
